(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["review-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.KonaReviewBadge) {
      window.KonaReviewBadge.refresh();
      return;
    }

    const cacheKey = 'kona_shop_review_count';
    const cacheLifetime = 6 * 60 * 60 * 1000;
    let observer;

    const readCount = (root = document) => {
      const countElement = root.querySelector('.jdgm-reviews-count');
      const directCount = Number.parseInt(countElement?.textContent?.replace(/[^0-9]/g, '') || '', 10);
      if (directCount > 0) return directCount;

      const reviewInfo = root.querySelector('.jdgm-header-info');
      const match = reviewInfo?.textContent?.match(/\(([\d,]+)\)/);
      return match ? Number.parseInt(match[1].replace(/,/g, ''), 10) : 0;
    };

    const updateBadges = (count) => {
      if (!Number.isFinite(count) || count < 1) return false;

      const roundedCount = Math.floor(count / 50) * 50;
      const displayCount = `${roundedCount.toLocaleString()}+`;

      document.querySelectorAll('[data-kona-review-badge]').forEach((badge) => {
        const countElement = badge.querySelector('[data-kona-review-count]');
        if (countElement) countElement.textContent = displayCount;

        const labelTemplate = badge.dataset.reviewLabelTemplate;
        if (labelTemplate) badge.setAttribute('aria-label', labelTemplate.replace('__COUNT__', displayCount));
        badge.dataset.reviewCount = String(count);
      });

      return true;
    };

    const saveCount = (count) => {
      try {
        localStorage.setItem(cacheKey, JSON.stringify({ count, savedAt: Date.now() }));
      } catch (error) {
        return false;
      }
      return true;
    };

    const readCachedCount = () => {
      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey));
        if (cached?.count > 0 && Date.now() - cached.savedAt < cacheLifetime) return cached.count;
      } catch (error) {
        return 0;
      }
      return 0;
    };

    const usePageCount = () => {
      const count = readCount();
      if (!count) return false;
      updateBadges(count);
      saveCount(count);
      return true;
    };

    const fetchShopCount = async () => {
      if (window.location.pathname === '/') return;

      try {
        const response = await fetch('/', { credentials: 'same-origin', cache: 'force-cache' });
        if (!response.ok) return;
        const markup = await response.text();
        const page = new DOMParser().parseFromString(markup, 'text/html');
        const count = readCount(page);
        if (!count) return;
        updateBadges(count);
        saveCount(count);
      } catch (error) {
        return;
      }
    };

    const refresh = () => {
      const cachedCount = readCachedCount();
      if (cachedCount) updateBadges(cachedCount);

      if (usePageCount()) return;
      if (!cachedCount) fetchShopCount();

      observer?.disconnect();
      observer = new MutationObserver(() => {
        if (usePageCount()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => observer?.disconnect(), 10000);
    };

    window.KonaReviewBadge = { refresh };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refresh, { once: true });
    } else {
      refresh();
    }

    document.addEventListener('shopify:section:load', refresh);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["softboard-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
    const trackingRoot = document.querySelector('[data-softboard-analytics]');
    if (!trackingRoot || trackingRoot.dataset.bound === 'true') return;

    trackingRoot.dataset.bound = 'true';

    const context = {
      page_type: trackingRoot.dataset.pageType || '',
      page_handle: trackingRoot.dataset.pageHandle || '',
      collection_handle: trackingRoot.dataset.collectionHandle || '',
      page_path: window.location.pathname,
    };

    const publish = (eventName, eventData = {}) => {
      trackingRoot.dataset.lastEvent = eventName;
      const payload = { ...context, ...eventData };
      trackingRoot.dataset.lastEventData = JSON.stringify(payload);

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, ...payload });
      }

      try {
        if (window.Shopify?.analytics?.publish) {
          window.Shopify.analytics.publish(eventName, payload);
        }
      } catch (error) {
        trackingRoot.dataset.publishError = error.name;
      }

      try {
        window.dispatchEvent(new CustomEvent('kona:soft-tops-event', {
          detail: { name: eventName, data: payload },
        }));
      } catch (error) {
        trackingRoot.dataset.dispatchError = error.name;
      }
    };

    document.addEventListener('click', (event) => {
      const trackingTarget = event.target.closest?.('[data-softboard-track]');
      if (!trackingTarget) return;

      publish(trackingTarget.dataset.softboardTrack, {
        link_url: trackingTarget.getAttribute('href') || '',
        board_name: trackingTarget.dataset.boardName || '',
        board_handle: trackingTarget.dataset.boardHandle || '',
        finder_choice: trackingTarget.dataset.finderChoiceLabel || '',
        position: Number(trackingTarget.dataset.position || 0),
      });
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches?.('input, select')) return;
      if (!event.target.closest('#shop-all')) return;

      const isInput = event.target.matches('input');
      const isTextEntry = isInput && ['search', 'text'].includes(event.target.type);
      const isToggle = isInput && ['checkbox', 'radio'].includes(event.target.type);
      const filterGroup = event.target.closest('[data-filter-name]');
      const filterOption = event.target.closest('[data-filter-value]');

      publish('soft_tops_filter_used', {
        filter_name: filterGroup?.dataset.filterName || event.target.name || event.target.id || event.target.type,
        filter_action: isToggle ? (event.target.checked ? 'selected' : 'deselected') : 'changed',
        filter_value: isTextEntry ? 'entered' : filterOption?.dataset.filterValue || event.target.value,
      });
    });

    document.addEventListener('toggle', (event) => {
      const faqItem = event.target.closest?.('[data-softboard-faq]');
      if (!faqItem?.open) return;

      publish('soft_tops_faq_open', {
        faq_question: faqItem.dataset.faqQuestion || '',
        position: Number(faqItem.dataset.position || 0),
      });
    }, true);

    document.addEventListener('submit', (event) => {
      if (!event.target.matches?.('form')) return;
      if (context.page_handle !== 'wholesale-inquiries') return;
      if (!event.target.action.includes('/contact')) return;

      publish('soft_tops_wholesale_submit', {
        form_id: event.target.id || 'contact_form',
      });
    });

    if (context.page_handle === 'wholesale-inquiries') {
      const params = new URLSearchParams(window.location.search);
      if (params.get('contact_posted') === 'true' && sessionStorage.getItem('soft_tops_wholesale_success') !== window.location.href) {
        publish('soft_tops_wholesale_success');
        sessionStorage.setItem('soft_tops_wholesale_success', window.location.href);
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
